import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MaintenancePopup from './components/MaintenancePopup';
import PopupPromo from './components/PopupPromo';

import Home from './pages/Home';
import Destinos from './pages/Destinos';
import Contacto from './pages/Contacto';
import Paquetes from './pages/Paquetes';
import PaqueteDetail from './pages/PaqueteDetail';
import Arrepentimiento from './pages/Arrepentimiento';
import FAQ from './pages/FAQ';
import PaginaCMS from './pages/PaginaCMS';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Admin from './pages/Admin';
import TravelSale from './pages/TravelSale';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';


import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// ✅ Componente wrapper para controlar visibilidad de botones globales
const GlobalButtons = () => {
  const location = useLocation();
  const esPaqueteDetail = location.pathname.startsWith('/paquete/');
  
  // En PaqueteDetail: ocultar en mobile (se manejan localmente)
  if (esPaqueteDetail) {
    return (
      <div className="hidden lg:block">
        <ScrollToTop />
        <WhatsAppButton />
      </div>
    );
  }
  
  
  // En otras páginas: mostrar normalmente
  return (
    <>
      <ScrollToTop />
      <WhatsAppButton />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        {/*<MaintenancePopup /> */}
          <Router>
            <PopupPromo />
            <GlobalButtons />
            <Routes>
              {/* ===== RUTAS ESPECÍFICAS (DEBEN IR PRIMERO) ===== */}
              
              {/* Página principal */}
              <Route path="/" element={<Home />} />
              
              {/* Rutas de navegación principales */}
              <Route path="/home" element={<Home />} />
              <Route path="/destinos" element={<Destinos />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              
              {/* Paquetes - IMPORTANTE: Estas deben ir ANTES de /:slug */}
              {/* Paquetes - con y sin destino como parámetro */}
              <Route path="/paquetes" element={<Paquetes />} />
              <Route path="/paquetes/:destino" element={<Paquetes />} />
              <Route path="/paquete/:slug" element={<PaqueteDetail />} />
              
              {/* FAQ */}
              <Route path="/preguntas-frecuentes" element={<FAQ />} />
              <Route path="/faq" element={<Navigate to="/preguntas-frecuentes" replace />} />
              <Route path="/FAQ" element={<Navigate to="/preguntas-frecuentes" replace />} />

              <Route path="/arrepentimiento" element={<Arrepentimiento />} />
              
              {/* Páginas CMS */}
              <Route path="/paginas/:slug" element={<PaginaCMS />} />
              
              {/* TravelSale */}
              <Route path="/travelsale" element={<TravelSale />} />
              <Route path="/travel-sale/:slug" element={<TravelSale />} />
              
              {/* Admin - Ruta protegida */}
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <Admin />
                  </ProtectedRoute>
                } 
              />
              
              {/* ===== RUTA DINÁMICA (DEBE IR AL FINAL) ===== */}
              {/* Esta captura cualquier slug no definido arriba */}
              <Route path="/:slug" element={<TravelSale />} />
              
              {/* Ruta 404 - Última de todas */}
              <Route path="*" element={
                <div className="min-h-screen flex items-center justify-center">
                  <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
                    <p className="text-gray-600">Página no encontrada</p>
                  </div>
                </div>
              } />
            </Routes>
          </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;